import actionType from '../constants/notifications'
import { store } from 'src/store/store';
import $axios from 'src/utils/axios';
import { setSowNotifications, setMaterialNotifications } from 'src/store/feature/notification/notificationSlice';
export const requestMaterialNotifications = (company_id, project_id) => {

  $axios.get(`notification/material/requests?project_id=${project_id}&page=1&per_page=9999&search=`).then((response) => {
    store.dispatch(setMaterialNotifications(response?.data?.data));
  })
}

export const requestSowNotifications = (company_id, project_id) => {
  $axios.post('sow/notifications',{ company_id: company_id, project_id: project_id }).then((response) => {
    store.dispatch(setSowNotifications(response?.data?.response));
  })
}



export const action_newNotification = (notifications) => {
  console.log(notifications, 'HERE IS ME')

  return {
    type : actionType.NEW_NOTIFICATIONS,
    notifications
  }
}

export const workItemStatusNotification = (project_id) => {
  const endpoints = [
    `project/work_item/overdue?project_id=${project_id}`,
    `project/work_item/to_start?project_id=${project_id}`,
    `project/work_item/to_end?project_id=${project_id}`,
  ];

  return Promise.all(endpoints.map((endpoint) => $axios.get(endpoint)))
    .then((responses) => {
      const data = responses.flatMap((response) => response.data.data);
      return data;
    })
    .catch((error) => {
      throw error;
    });
};
